import { Show, createMemo } from "solid-js";

import { useClient } from "@revolt/client";
import { useDevice } from "@revolt/common";
import { useParams } from "@revolt/routing";
import { useState } from "@revolt/state";

/**
 * Majalis: Dashboard | Majalis switcher above the channel sidebar
 * (desktop only; phones keep the server rail). It stays mounted while the
 * sidebar below it changes, so the gold highlight can slide between tabs.
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
export function MajalisNav() {
  const { isMobile } = useDevice();
  const client = useClient();
  const state = useState();
  const params = useParams<{ server: string }>();

  const server = (): any => (client()?.servers.toList() ?? [])[0];
  const onServer = () => !!params.server;

  const unread = createMemo(
    () =>
      state.ordering
        .orderedConversations(client())
        .filter((c: any) => c.unread).length,
  );

  const tab = (active: boolean) =>
    "position:relative;z-index:1;flex:1;min-width:0;display:flex;align-items:center;justify-content:center;gap:8px;padding:9px 10px;border-radius:12px;font-size:13px;font-weight:700;text-decoration:none;transition:color .25s ease;color:" +
    (active ? "#FFC62E;" : "var(--md-sys-color-on-surface-variant);");

  return (
    <Show when={true}>
      <div style="flex-shrink:0;padding:10px 10px 6px;">
        <div style="position:relative;display:flex;gap:6px;">
          <div
            aria-hidden="true"
            style={
              "position:absolute;top:0;bottom:0;left:0;width:calc(50% - 3px);box-sizing:border-box;border-radius:12px;background:#241d0c;border:1px solid #5a4716;box-shadow:0 0 16px rgba(255,198,46,0.16);transition:transform .3s cubic-bezier(.4,0,.2,1);transform:" +
              (onServer() ? "translateX(calc(100% + 6px));" : "translateX(0);")
            }
          />
          <a data-tour="dash" href="/app" style={tab(!onServer())}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <rect x="3.5" y="3.5" width="7" height="7" rx="1.5" />
              <rect x="13.5" y="3.5" width="7" height="7" rx="1.5" />
              <rect x="3.5" y="13.5" width="7" height="7" rx="1.5" />
              <rect x="13.5" y="13.5" width="7" height="7" rx="1.5" />
            </svg>
            <span>Dashboard</span>
            <Show when={unread() > 0}>
              <span style="min-width:18px;padding:1px 6px;border-radius:999px;background:#E2B04A;color:#1a1200;font-size:11px;font-weight:700;text-align:center;">
                {unread()}
              </span>
            </Show>
          </a>
          <Show when={server()}>
            <a
              data-tour="rooms"
              href={state.layout.getLastActiveServerPath(server().id)}
              style={tab(onServer())}
            >
              <Show when={server().iconURL}>
                <img
                  src={server().iconURL}
                  alt=""
                  style="width:20px;height:20px;border-radius:50%;object-fit:cover;"
                />
              </Show>
              <span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
                {String(server().name).replace(/^the\s+/i, "")}
              </span>
            </a>
          </Show>
        </div>
      </div>
    </Show>
  );
}
